import { HiOutlineUser } from "react-icons/hi2";
import { TbMessage } from "react-icons/tb";
import { BsTag } from 'react-icons/bs'
import { LuCalendarDays } from 'react-icons/lu'

const labelTags = [
  { icon: <HiOutlineUser />, label: 'admin' },
  { icon: <LuCalendarDays />, label: 'April 16, 2025' },
  { icon: <TbMessage />, label: '0 Comments' },
  { icon: <BsTag />, label: 'Pathology' },
]

const BlogDetailHeroSection = ({ blogData }) => {
  return (
    <>
      <figure data-aos={"zoom-in"} data-aos-duration="700" className="w-full md:h-[400px] h-[210px] rounded-3xl overflow-hidden">
        <img
          className="w-full h-full object-cover object-center"
          src={blogData?.image}
          alt="blog-image"
        />
      </figure>
      <div data-aos="fade-up" data-aos-duration="700" className="flex flex-wrap items-center gap-5 uppercase font-medium">
        {blogData?.label?.map(({ image, text }, index) => <h1 key={index} className="flex items-center gap-1 hover:text-[#0BB6D9] transition-all duration-500 cursor-pointer"><img className='h-4 w-4' src={image} alt="tag-image" /> {text}</h1>)}
      </div>
    </>
  )
}

export default BlogDetailHeroSection